<template>
  <div class="space-y-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Degree / Qualification -->
      <div class="space-y-2">
        <label class="text-[14px] font-bold text-foreground">Degree</label>
        <input
          :value="item.degree"
          @input="update('degree', $event.target.value)"
          type="text"
          placeholder="Bachelor of Science"
          class="w-full px-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
        />
      </div>

      <!-- Start Date -->
      <div class="space-y-2">
        <label class="text-[14px] font-bold text-foreground">Start date*</label>
        <div class="grid grid-cols-2 gap-3">
          <select
            :value="item.startMonth"
            @change="update('startMonth', $event.target.value)"
            class="w-full px-4 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-muted-foreground outline-none focus:ring-1 focus:ring-primary/20 appearance-none bg-[url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M5%207.5L10%2012.5L15%207.5%22%20stroke%3D%22%23666%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3C/svg%3E')] bg-[length:20px_20px] bg-[right_16px_center] bg-no-repeat"
          >
            <option value="" disabled>Month</option>
            <option v-for="m in months" :key="m" :value="m">{{ m }}</option>
          </select>
          <input
            :value="item.startYear"
            @input="update('startYear', $event.target.value)"
            type="text"
            placeholder="Year"
            class="w-full px-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
          />
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- School / University -->
      <div class="space-y-2">
        <label class="text-[14px] font-bold text-foreground">School*</label>
        <input
          :value="item.school"
          @input="update('school', $event.target.value)"
          type="text"
          placeholder="University of Lagos"
          class="w-full px-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
          required
        />
      </div>

      <!-- End Date -->
      <div class="space-y-2">
        <label class="text-[14px] font-bold text-foreground">End date*</label>
        <div class="grid grid-cols-2 gap-3">
          <select
            :value="item.endMonth"
            @change="update('endMonth', $event.target.value)"
            class="w-full px-4 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-muted-foreground outline-none focus:ring-1 focus:ring-primary/20 appearance-none bg-[url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M5%207.5L10%2012.5L15%207.5%22%20stroke%3D%22%23666%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3C/svg%3E')] bg-[length:20px_20px] bg-[right_16px_center] bg-no-repeat"
          >
            <option value="" disabled>Month</option>
            <option v-for="m in months" :key="m" :value="m">{{ m }}</option>
          </select>
          <input
            :value="item.endYear"
            @input="update('endYear', $event.target.value)"
            type="text"
            placeholder="Year"
            class="w-full px-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EducationForm",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  methods: {
    update(key, value) {
      this.$emit("update", { [key]: value });
    },
  },
};
</script>
